import PropTypes from 'prop-types'

import { Box, Link } from '@mui/material'
import TooltipButton from '../../../ui/components/tooltipButton'

import styles from './styles'

const LinkBack = ({ text, tooltipText, placementTooltip, onClick }) => {
  return (
    <Box sx={styles.linkButtonTooltip}>
      <Link component="button" onClick={onClick} sx={styles.linkButton}>
        {text}
      </Link>
      {tooltipText ? (
        <TooltipButton placement={placementTooltip} title={tooltipText} />
      ) : null}
    </Box>
  )
}

LinkBack.propTypes = {
  text: PropTypes.string,
  tooltipText: PropTypes.string,
  placementTooltip: PropTypes.string,
  onClick: PropTypes.func,
}

export default LinkBack
